export default "__VITE_ASSET__46e92471__"